import { InspectionFlwBaselineModel, InspectionFlwBaselineControlPointWriteModel } from "../entities/InspectionFlwBaselineModel";
import BaseRepository from "./BaseRepository";

export class InspectionFlwBaselineRepo extends BaseRepository {

  async getControlPoints(inspectionId: number) {
    const url = `Inspection/${inspectionId}/InspectionFlwBaseline`;
    const response = await this.client.get(url);
    return this.handleResponse<InspectionFlwBaselineModel[]>(response);
  }

  async addControlPoint(inspectionId: number, body: InspectionFlwBaselineControlPointWriteModel) {
    const url = `Inspection/${inspectionId}/InspectionFlwBaseline/Add`;
    const response = await this.client.post(url, body);
    return this.handleResponse<InspectionFlwBaselineModel>(response);
  }

  async updateControlPoint(inspectionId: number, cpId: number, body: InspectionFlwBaselineControlPointWriteModel) {
    const url = `Inspection/${inspectionId}/InspectionFlwBaseline/Update/${cpId}`;
    const response = await this.client.put(url, body);
    const handled = this.handleResponse(response);
    return handled !== undefined;
  }

  async deleteControlPoint(inspectionId: number, cpId: number) {
    const url = `Inspection/${inspectionId}/InspectionFlwBaseline/Delete/${cpId}`;
    const response = await this.client.delete(url);
    const handled = this.handleResponse(response);
    return handled !== undefined;
  }

  async getFlwBaselineChart(inspectionId: number) {
    const url = `Inspection/${inspectionId}/InspectionFlwBaseline/Chart`;
    const response = await this.client.get<{ position: number; wallThickness: number }[]>(url);
    return this.handleResponse<{ position: number; wallThickness: number }[]>(response);
  }
}

export default InspectionFlwBaselineRepo;
